import { Switch } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import styled from 'styled-components';

const StyledSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  &.isChecked {
    color: ${getColor('malachite')};
  }
  &:not(.isChecked) {
    color: ${getColor('shuttleGray')};
  }
`;

const SwitchWrapper = ({ title, isChecked, onToggle }) => {
  return (
    <StyledSwitchWrapper className={boolPropsToClassNames({ isChecked })}>
      <Switch onClick={onToggle} checked={isChecked} />
      {title}
    </StyledSwitchWrapper>
  );
};

export default SwitchWrapper;
